module.exports = __webpack_public_path__ + "media/thirdSection/2-55eb089e.png";